import React from 'react';
import { Phone, Mail, MapPin, Facebook, Instagram, Linkedin as LinkedIn, Clock } from 'lucide-react';
import { useLanguage } from '../contexts/LanguageContext';

export function Footer() {
  const { t } = useLanguage();
  
  return (
    <footer className="bg-gray-900 text-white">
      <div className="max-w-7xl mx-auto py-12 px-4 sm:px-6 lg:px-8">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-8">
          <div>
            <h3 className="text-lg font-semibold mb-4">Asena UG</h3>
            <p className="text-gray-400">
              {t('footer.description')}
            </p>
            <div className="mt-4 flex space-x-4">
              <a href="https://facebook.com" target="_blank" rel="noopener noreferrer" className="text-gray-400 hover:text-white">
                <Facebook className="h-6 w-6" />
              </a>
              <a href="https://instagram.com" target="_blank" rel="noopener noreferrer" className="text-gray-400 hover:text-white">
                <Instagram className="h-6 w-6" />
              </a>
              <a href="https://linkedin.com" target="_blank" rel="noopener noreferrer" className="text-gray-400 hover:text-white">
                <LinkedIn className="h-6 w-6" />
              </a>
            </div>
          </div>

          <div>
            <h3 className="text-lg font-semibold mb-4">{t('footer.contact.title')}</h3>
            <ul className="space-y-2 text-gray-400">
              <li className="flex items-center">
                <Phone className="h-5 w-5 mr-2" />
                +49 (0) 40 37 6129 52
              </li>
              <li className="flex items-center">
                <Mail className="h-5 w-5 mr-2" />
                info@asena-ug.de
              </li>
              <li className="flex items-center">
                <MapPin className="h-5 w-5 mr-2" />
                Holzmühlenstraße 33 <br /> 22041,
                Hamburg, Germany
              </li>
              <li className="flex items-center">
                <Clock className="h-5 w-5 mr-2" />
                Mo-Fr: 8:00 - 17:00
              </li>
            </ul>
          </div>

          <div>
            <h3 className="text-lg font-semibold mb-4">{t('services.title')}</h3>
            <ul className="space-y-2">
              <li>
                <a href="/services#commercial" className="text-gray-400 hover:text-white">
                  {t('services.categories.commercial.title')}
                </a>
              </li>
              <li>
                <a href="/services#industrial" className="text-gray-400 hover:text-white">
                  {t('services.categories.special.title')}
                </a>
              </li>
              <li>
                <a href="/services#special" className="text-gray-400 hover:text-white">
                  {t('services.categories.institutional.title')}
                </a>
              </li>
              <li>
                <a href="/services#residential" className="text-gray-400 hover:text-white">
                  {t('services.categories.specialized.title')}
                </a>
              </li>
            </ul>
          </div>

          <div>
            <h3 className="text-lg font-semibold mb-4">{t('footer.legal.title')}</h3>
            <ul className="space-y-2">
              <li>
                <a href="/impressum" className="text-gray-400 hover:text-white">
                  Impressum
                </a>
              </li>
              <li>
                <a href="/privacy" className="text-gray-400 hover:text-white">
                  {t('footer.legal.privacy')}
                </a>
              </li>
              <li>
                <a href="/terms" className="text-gray-400 hover:text-white">
                  {t('footer.legal.terms')}
                </a>
              </li>
            </ul>
          </div>
        </div>

        <div className="mt-8 pt-8 border-t border-gray-800">
          <p className="text-center text-gray-400">
            © {new Date().getFullYear()} Asena UG. {t('footer.rights')}
          </p>
        </div>
      </div>
    </footer>
  );
}